import * as actions from '../../redux/actions';

import CommonService from '../../../../services/commonService';
import HeroSection from '../../common/HeroSection/HeroSection';
import KuposHelmet from '../../../common/KuposHelmet';
import React from 'react';
import ThemeFourAboutIconSection from '../common/ThemeFourAboutIconSection';
import ThemeFourTitle from '../common/ThemeFourTitle';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';

const ThemeFourAboutUsScreen = ({ home }) => {
	const operator = CommonService.getLocal('op') || home.operator;
	const name = operator && operator.operator_name;

	const createMarkup = data => {
		return { __html: data };
	};

	// Function to process the about_us content
	const getAboutUsContent = () => {
		if (operator && operator.about_us) {
			let content = operator.about_us.split('///')[0];
			if (name === 'santajuana') {
				const paragraphs = content.split('</p>');

				if (paragraphs[0]) {
					const words = paragraphs[0].split(' ');
					const hardCodedText = `<span style="color: #50bbf2;font-weight: bold ;">Transportes Santa Juana SpA</span>`;
					paragraphs[0] = `${hardCodedText} ${words.slice(4).join(' ')}</p>`;
				}

				return paragraphs.join('</p>');
			} else {
				return content;
			}
		}
		return '';
	};




	return (

		<div>
			<KuposHelmet />

			<HeroSection
				heroImage={getIcons('aboutUsBanner', operator)}
				title={'La empresa'}
				height={'43vh'}
				marginTop="-18px"
				description={'Home / La empresa'}
			/>

			<ThemeFourTitle title="Conocer acerca de nosotros" />

			<div className="new-container " style={{ display: 'flex', gap: '20px' }}>
				<div style={{ flex: 0.7 }}>
					<img
						style={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}
						src={getIcons('aboutUsImage', operator)}
						alt=""
					/>
				</div>
				<div
					dangerouslySetInnerHTML={createMarkup(getAboutUsContent())}
					className="lh-1-3 font11 justify-text "
					style={{ flex: 1 }}
				/>
			</div>

			{name === 'pullmandelsur' ? null : (
				<ThemeFourTitle title="Ofrecemos un servicio de calidad" />
			)}

			<ThemeFourAboutIconSection />


			{operator && operator.operator_name === "saopaulo" ? (<div className="new-container ">
				{getIcons('aboutUsSecondBanner', operator) && (
					<div>
						<img
							style={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}
							src={getIcons('aboutUsSecondBanner', operator)}
							alt=""
						/>
					</div>
				)}
				<div
					dangerouslySetInnerHTML={createMarkup(
						operator && operator.about_us ? operator.about_us.split('///')[1] : '',
					)}
					className="lh-1-3 font11 justify-text "
				/>
			</div>)
				: ('')

			}



		</div>
	);


};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeFourAboutUsScreen);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeFour/ThemeFourPages/ThemeFourAboutUsScreen.js